import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function Spinner({ className = 'size-5' }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <span role="status" aria-label={t('common.loading')} className="inline-flex">
      <Loader2 className={`animate-spin ${className}`} aria-hidden="true" />
    </span>
  );
}

export function FullPageSpinner() {
  return (
    <div className="flex min-h-dvh items-center justify-center">
      <Spinner className="size-8 text-brand-700" />
    </div>
  );
}
